import React from "react";
import { browserHistory } from "react-router";
import { useSelector } from "react-redux";
import { readSingleAppData } from "modules/shared/redux-store/dataReaders";
import Moment from "moment";
import { FSMoneyFactory } from "../../shared/helpers/money/moneyFactory";
import { MoneyFormatter } from "../../shared/helpers/money/moneyFormatter";
import DigitalizedOrderDetail from "../../shared/components/digitalized-orders/DigitalizedOrderDetail";

export const DigitalizedOrdersDetailPage = () => {
  const order = useSelector(s => readSingleAppData(s, "digitalizedOrder"));

  const handleButtonClick = () => {
    browserHistory.push("/startups/digitalized_orders");
  };

  return (
    <DigitalizedOrderDetail
      merchantStoreName={order?.orders[0]?.merchantStoreName}
      orderDate={Moment(order?.orderChannelable?.orderDate).format(
        "DD.MM.YYYY",
      )}
      orderMethod={order?.orderChannelable?.orderMethod}
      contactPerson={order?.orderChannelable?.contactPerson}
      furtherInformation={order?.orderChannelable?.furtherInformation}
      orderItems={order?.orders[0]?.orderItems}
      discountsInKind={order?.orders[0]?.discountsInKind}
      grossPrice={MoneyFormatter.fromBigCents(
        FSMoneyFactory.toMoney(order?.orders[0]?.grossSumCents),
      )}
      buttonOnClick={handleButtonClick}
      buttonText="Zurück zur Übersicht"
    />
  );
};
